import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Helvetica, Arial, sans-serif",
      background: "#f7fafc",
      color: "#2d3748",
    }}>
      <div style={{ fontSize: "80px", lineHeight: 1 }}>404</div>
      <h2 style={{ fontSize: "22px", fontWeight: "700", margin: "12px 0 8px" }}>
        Page Not Found
      </h2>
      <p style={{ color: "#718096", marginBottom: "24px" }}>
        The page you're looking for doesn't exist.
      </p>
      <Link
        to="/dashboard"
        style={{
          padding: "10px 24px",
          background: "#1e3a5f",
          color: "#fff",
          borderRadius: "6px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        Go to Dashboard
      </Link>
      
      
    </div>
  );
}